export async function connectWordPressOAuthIntegration(siteUrl: string): Promise<boolean> {
  try {
    // Start OAuth flow with site URL parameter
    const authUrl = `${process.env.NEXT_PUBLIC_BACKEND_API_ENDPOINT_URI}/v2/oauth/wordpress/authorize?siteUrl=${encodeURIComponent(siteUrl)}`

    return new Promise<boolean>((resolve) => {
      const popup = window.open(
        authUrl,
        'wordpress-oauth',
        'width=500,height=600,scrollbars=yes,resizable=yes'
      )

      if (!popup) {
        resolve(false)
        return
      }

      const checkClosed = setInterval(() => {
        if (popup.closed) {
          clearInterval(checkClosed)
          channel.close()
          resolve(false)
        }
      }, 1000)

      // Listen for OAuth completion message via BroadcastChannel
      const channel = new BroadcastChannel('oauth_channel')
      channel.onmessage = (event) => {
        // Only handle WordPress OAuth messages
        if (!event.data || !event.data.type || !event.data.type.startsWith('WORDPRESS_OAUTH_')) {
          return
        }

        if (event.data.type === 'WORDPRESS_OAUTH_SUCCESS') {
          clearInterval(checkClosed)
          popup.close()
          channel.close()
          resolve(true)
        } else if (event.data.type === 'WORDPRESS_OAUTH_ERROR') {
          clearInterval(checkClosed)
          popup.close()
          channel.close()
          resolve(false)
        }
      }
    })
  } catch (error) {
    console.error('WordPress OAuth connection error:', error)
    return false
  }
}
